export default __webpack_public_path__ + "static/media/dealer-3.46aac6cc.png";